import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { LandingPage } from "@/pages/LandingPage";
import { TrackingPage } from "@/pages/TrackingPage";
import { ShortlinkRedirect } from "@/pages/ShortlinkRedirect";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/track/:reference" element={<TrackingPage />} />
          <Route path="/s/:slug" element={<ShortlinkRedirect />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            borderRadius: 0,
            border: "1px solid #000",
            fontFamily: "IBM Plex Sans, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
